/* eslint-disable */
"use strict";
import Semaphore from "semaphore-async-await";
import errorService from "@/services/errorService";
import _ from "lodash";
const NodeCache = require("node-cache");
const configCache = new NodeCache();

/* const FIFO = require('fast-fifo')
const q = new FIFO() */
const lock = new Semaphore(1);

console.log("configurazioni service: ", service);

var config, service, configurazioni;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  configurazioni = config.VUE_APP_MOL_S_CONFIGURATIONS
}

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    configCache.flushAll();
    const response = await fetch(`${service}/${configurazioni}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${configurazioni}/mode`);
    return await response.json();
  } catch {
    return {
      modulo: "CONFIGURAZIONI",
      locale: "---",
      remote: "---",
      versione: "---",
      health: "---",
    };
  }
}

// TODO: Unica soluzione trovata per precaricare la cache. lock non funziona....
// Problema: SU documenti lunghi, viene richiamata n volte l'unità di misura ma fa n chiamate al server delle configurazioni,
// non fa in tempo ad inserirla nella cache
// --> La precarico nella cache in modo che la trova anche la prima volta

function getKey(configurazioneId, subConf) {
  return `${configurazioneId}${subConf ? subConf : ""}`;
}

function testCache(configurazioneId, subConf) {
  const key = getKey(configurazioneId, subConf);
  return !configCache.has(key);
}

async function caricaCacheDefault() {
  console.log("cache default");
  if (testCache("backoffice", "")) {
    const bk = await getConfigurazione("backoffice", "");
    configCache.set(getKey("backoffice", "impostazioni"), bk.impostazioni);
    configCache.set(getKey("backoffice", "pagine"), bk.pagine);
  }
  testCache("listini", "") && (await getConfigurazione("listini", ""));
  testCache("prodotti_reparti_fiscali", "reparti") &&
    (await getConfigurazione("prodotti_reparti_fiscali", "reparti"));
  testCache("prodotti_unita_misura", "um") &&
    (await getConfigurazione("prodotti_unita_misura", "um"));
  testCache("prodotti_aliquote_iva", "aliquote") &&
    (await getConfigurazione("prodotti_aliquote_iva", "aliquote"));
  testCache("magazzino_magazzini", "magazzini") &&
    (await getConfigurazione("magazzino_magazzini", "magazzini"));
  testCache("documenti_pagamento", "") &&
    (await getConfigurazione("documenti_pagamento", ""));
}

async function clearCache() {
  configCache.flushAll();
}

function invalidaCache(configurazioneId, subConf) {
  if (!testCache(configurazioneId, subConf)) {
    configCache.del(getKey(configurazioneId, subConf));
  }
}

async function searchConfigurazioni(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${configurazioni}/search?flt=${searchText}`
  );
  return await response.json();
}

async function getInfoBarcode(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${configurazioni}/barcode?flt=${searchText}`
  );
  return await response.json();
}

async function getElencoConfigurazioni() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${configurazioni}?keys=true`);
  const result = await response.json();
  return result.rows;
}

/* async function getConfigurazione(configurazioneId, subConf) {
  let result = lock.execute(async () => await getConfigurazioneLocked(configurazioneId, subConf))
  // const result = await getConfigurazioneLocked(configurazioneId, subConf)

  return result
}
 */
async function getConfigurazione(configurazioneId, subConf) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const key = `${configurazioneId}${subConf ? subConf : ""}`;
    const value = configCache.get(key);
    if (value !== undefined) {
      return value;
    }
    // console.log('getConfigurazione',configurazioneId, subConf)
    const response = await fetch(
      `${service}/${configurazioni}/${configurazioneId}${
        subConf ? "/" + subConf : ""
      }`
    );
    const result = await response.json();

    configCache.set(key, result);
    return result;
  } catch (error) {
    errorService.onError(error, "getConfigurazione");
  }
}

async function creaConfigurazione(configurazione) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${configurazioni}/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(configurazione),
  });
  return await response.json();
}

async function modificaConfigurazione(configurazione) {
  if (!config || !service) {
    await getConfigFile();
  }
  invalidaCache(configurazione._id);
  const response = await fetch(
    `${service}/${configurazioni}/${configurazione._id}/update`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(configurazione),
    }
  );
  return await response.json();
}

async function getBarcodeInfo(tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${configurazioni}/barcode/tipo/${tipo}`
  );
  return await response.json();
}

async function setBarcodeInfo(tipo, operazione, counter) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    operazione,
    counter,
  };
  const response = await fetch(
    `${service}/${configurazioni}/barcode/tipo/${tipo}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return await response.json();
}

async function getOperatori(tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${configurazioni}/operatori`);
  const result = await response.json();
  return tipo && result ? result.filter((x) => x[tipo]) : result || [];
}

async function getOperatore(pin) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${configurazioni}/operatori/${pin}`);
  return await response.json();
}

async function aggiornaCategorie(configurazioneId, subConf, categorie, tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    configCache.flushAll();
    let categorieEsistenti = await getConfigurazione(configurazioneId, subConf);
    let categorieDiverse = [];
    if (tipo) {
      categorieDiverse = categorieEsistenti.filter((x) => x.tipo !== tipo);
      categorieEsistenti = categorieEsistenti.filter((x) => x.tipo === tipo);
    }
    if (categorie.length === 0) return categorieEsistenti;
    if (categorie[0].codice) {
      // categorie = _.unionBy(categorie, categorieEsistenti.filter(x => !_.isEmpty(x.codice)), 'codice')
      categorie = _.unionBy(
        categorie,
        categorieEsistenti.filter((x) => !_.isEmpty(x.codice)),
        (x) => {
          return x.codice + (x.tipo || "");
        }
      );
    } else {
      categorie = _.union(categorie, categorieEsistenti);
    }
    const configurazione = { _id: configurazioneId };
    var pattern = /[^a-zA-Z0-9-_]+/gi;
    for (let c of categorie) {
      let codice = String(c.codice)
        .toLowerCase()
        .trim();
      codice = _.replace(String(codice), " ", "_");
      codice = codice.replace(pattern, "_");
      c.codice = codice;
    }
    if (tipo) {
      categorie = categorie.concat(categorieDiverse);
    }
    configurazione[subConf] = categorie;
    await modificaConfigurazione(configurazione);
    return categorie;
  } catch (error) {
    console.log(`aggiornaCategorie errore: ${error}`);
    return null;
  }
}

async function aggiornaCategorieOld(configurazioneId, subConf, categorie) {
  try {
    configCache.flushAll();
    const categorieEsistenti = await getConfigurazione(
      configurazioneId,
      subConf
    );
    if (categorie.length === 0) return categorieEsistenti;
    if (categorie[0].codice) {
      categorie = _.unionBy(
        categorie,
        categorieEsistenti.filter((x) => !_.isEmpty(x.codice)),
        "codice"
      );
    } else {
      categorie = _.union(categorie, categorieEsistenti);
    }
    const configurazione = { _id: configurazioneId };
    var pattern = /[^a-zA-Z0-9-_]+/gi;
    for (let c of categorie) {
      let codice = String(c.codice)
        .toLowerCase()
        .trim();
      codice = _.replace(String(codice), " ", "_");
      codice = codice.replace(pattern, "_");
      c.codice = codice;
    }
    configurazione[subConf] = categorie;
    await modificaConfigurazione(configurazione);
    return categorie;
  } catch (error) {
    console.log(`aggiornaCategorie errore: ${error}`);
    return null;
  }
}

async function getNumeratore(tipo, incrementa, annoRiferimento) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${configurazioni}/documenti/numeratore/${tipo}?inc=${incrementa}${
      annoRiferimento ? "&anno=" + annoRiferimento : ""
    }`
  );
  return await response.json();
}

async function setNumeroUltimo(tipo, anno, numero) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    anno,
    numero,
  };
  const response = await fetch(
    `${service}/${configurazioni}/documenti/numeratore/${tipo}/ultimo`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return await response.json();
}

async function getNumeratoreCliente(ragioneSociale) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    ragioneSociale,
  };
  const response = await fetch(
    `${service}/${configurazioni}/clienti/numeratore/`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return await response.json();
}

async function verificaAllineamentoNumeratori(elencoVerifiche) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${configurazioni}/documenti/numeratore/allineamento${
      elencoVerifiche ? "?test=" + elencoVerifiche : ""
    }`
  );
  return await response.json();
}

async function getMemoriaCondivisa(chiave) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${configurazioni}/memoria/${chiave}`
  );
  return await response.json();
}

async function takeMemoriaCondivisa(chiave) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${configurazioni}/memoria/take/${chiave}`
  );
  return await response.json();
}

async function setMemoriaCondivisa(chiave, valore) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    valore,
  };
  const response = await fetch(
    `${service}/${configurazioni}/memoria/${chiave}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return await response.json();
}

async function getk8FileListCliente(cliente) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    cliente,
  };
  const response = await fetch(
    `${service}/${configurazioni}/repository/cliente`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return await response.json();
}

async function getInfoUpload() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${configurazioni}/repository/info`);
  return await response.json();
}

async function uploadRepositoryMultipleFile(
  form_data,
  licenzeServer,
  base,
  cliente,
  prodotto,
  totem,
  idImmagine
) {
  try {
    const response = await fetch(
      `${licenzeServer}/utility/upload/attachments/multiple?base=${base}${
        cliente ? "&cliente=" + cliente : ""
      }${prodotto ? "&prodotto=" + prodotto : ""}${
        totem ? "&totem=" + totem : ""
      }${idImmagine ? "&idImmagine=" + idImmagine : ""}`,
      {
        method: "POST",
        body: form_data,
      }
    );
    return await response.text();
  } catch (err) {
    return err;
  }
}

async function deleteAttachmentFile(
  licenzeServer,
  base,
  cliente,
  prodotto,
  totem,
  file,
  codice
) {
  try {
    const response = await fetch(
      `${licenzeServer}/utility/attachments/delete${
        codice ? "/" + codice : ""
      }?base=${base}${cliente ? "&cliente=" + cliente : ""}${
        prodotto ? "&prodotto=" + prodotto : ""
      }${totem ? "&totem=" + totem : ""}${file ? "&fn=" + file : ""}`,
      {
        method: "POST",
      }
    );
    return await response.json();
  } catch (err) {
    return err;
  }
}

async function registraTodo({ actor, id, type, operation, payload }) {
  if (!config || !service) {
    await getConfigFile();
  }
  console.log("registra to do");
  const response = await fetch(`${service}/${configurazioni}/todo`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ actor, id, type, operation, payload }),
  });
  return await response.json();
}

export default {
  cicleSync,
  getRunMode,
  getElencoConfigurazioni,
  clearCache,
  invalidaCache,
  searchConfigurazioni,
  getInfoBarcode,
  getConfigurazione,
  creaConfigurazione,
  modificaConfigurazione,
  getBarcodeInfo,
  setBarcodeInfo,
  getOperatori,
  getOperatore,
  aggiornaCategorie,
  getNumeratore,
  setNumeroUltimo,
  getNumeratoreCliente,
  verificaAllineamentoNumeratori,
  caricaCacheDefault,
  getMemoriaCondivisa,
  takeMemoriaCondivisa,
  setMemoriaCondivisa,
  getInfoUpload,
  getk8FileListCliente,
  uploadRepositoryMultipleFile,
  deleteAttachmentFile,
  registraTodo,
};
